import { FC } from "react"
import { EyeOff } from "lucide-react"
import { DefaultBtn } from "../buttons"
import { PendingEmbedDomain } from "../../../types"

type Props = {
  domain: PendingEmbedDomain
  decline: (domain: PendingEmbedDomain) => Promise<boolean>
  /** Host currently being declined, from usePendingEmbedDomains. */
  decliningHost: string | null
  /** True while a row on the same list is mid-approve. */
  disabled?: boolean
  className?: string
}

/**
 * Clears a blocked domain the customer does not want to approve — an old
 * staging site, a scraper, a partner page they are done with — so it stops
 * being reported as needing a decision.
 *
 * It does NOT unblock anything: the domain stays off the approved-URL list and
 * the embed still will not load there. The label is "Hide" rather than
 * "Decline" or "Block" for exactly that reason — declining sounds like it
 * enforces something, and it does not.
 */
const DeclineDomainButton: FC<Props> = ({
  domain,
  decline,
  decliningHost,
  disabled = false,
  className = ""
}) => {
  const isDeclining = decliningHost === domain.host

  return (
    <DefaultBtn
      size="sm"
      className={`shrink-0 ${className}`}
      onClick={() => decline(domain)}
      isLoading={isDeclining}
      disabled={disabled || !!decliningHost}
      title={`Stop showing ${domain.host}. It stays blocked — you can undo this.`}
    >
      {!isDeclining && <EyeOff size={14} className="mr-1" />}
      Hide
    </DefaultBtn>
  )
}

export default DeclineDomainButton
